import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import ImageUploader from '../../components/admin/ImageUploader';

export default function HomePageManager() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  // Hero Section
  const defaultHeroTitle = 'GELECEĞİN YAPILARINI\nBUGÜNDEN İNŞA EDİYORUZ';
  const defaultHeroSubtitle = 'Modern mimari, üstün malzeme kalitesi ve konforlu yaşam alanlarıyla hayalinizdeki evi inşa ediyoruz. KARE YAPI ile tanışın, ayrıcalıklı yaşama adım atın.';
  
  const [heroTitle, setHeroTitle] = useState(defaultHeroTitle);
  const [heroSubtitle, setHeroSubtitle] = useState(defaultHeroSubtitle);
  const [heroBgUrl, setHeroBgUrl] = useState('');
  
  // Showcase Section (Binalarımızı Yakından Tanıyın)
  const defaultShowcaseTitle = 'Mühendislik Harikası.';
  const defaultShowcaseDesc = 'Sadece estetik değil; akıllı ev entegrasyonu, birinci sınıf ahşap işçiliği, kusursuz akustik izolasyon mimarisi ve devasa fore kazık zemin güçlendirmeleriyle nesiller boyu ayakta kalacak anıtsal projeler geliştiriyoruz.';

  const [showcaseTitle, setShowcaseTitle] = useState(defaultShowcaseTitle);
  const [showcaseDesc, setShowcaseDesc] = useState(defaultShowcaseDesc);
  const [showcaseImage1, setShowcaseImage1] = useState('');
  const [showcaseImage2, setShowcaseImage2] = useState('');

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const docRef = doc(db, 'pages', 'home');
        const snap = await getDoc(docRef);
        
        let dataToSave: any = {
          heroTitle, heroSubtitle, heroBgUrl, showcaseTitle, showcaseDesc, showcaseImage1, showcaseImage2
        };

        if (snap.exists() && snap.data().heroTitle) {
          const data = snap.data();
          
          if (data.heroTitle) setHeroTitle(data.heroTitle);
          
          // Recovery check for heroSubtitle
          if (data.heroSubtitle && data.heroSubtitle.includes('mimari mükemmellik ve güvenin buluştuğu')) {
             setHeroSubtitle(defaultHeroSubtitle);
             dataToSave.heroSubtitle = defaultHeroSubtitle;
          } else if (data.heroSubtitle) {
             setHeroSubtitle(data.heroSubtitle);
             dataToSave.heroSubtitle = data.heroSubtitle;
          }
          
          // Recovery check for showcaseTitle
          if (data.showcaseTitle && data.showcaseTitle === 'YENİ NESİL MİMARİ') {
             setShowcaseTitle(defaultShowcaseTitle);
             dataToSave.showcaseTitle = defaultShowcaseTitle;
          } else if (data.showcaseTitle) {
             setShowcaseTitle(data.showcaseTitle);
             dataToSave.showcaseTitle = data.showcaseTitle;
          }

          // Recovery check for heroBgUrl to force the new Esenyurt style premium image over old cached links
          let finalBgUrl = data.heroBgUrl;
          if (!finalBgUrl || finalBgUrl.includes('yapsat-site-7') || finalBgUrl.includes('hero-atlas') || finalBgUrl.includes('hero-dark')) {
             finalBgUrl = '/hero-esenyurt-1.png';
          }

          const defaultHeroUrl = finalBgUrl;
          
          let finalShowcase1 = data.showcaseImage1;
          if (!finalShowcase1 || finalShowcase1.includes('premium-project') || finalShowcase1.includes('masterpiece')) {
             finalShowcase1 = '/showcase-modern-1.png';
          }
          
          const defaultShowcase1 = finalShowcase1;
          const defaultShowcase2 = data.showcaseImage2 || '/premium-project-block.png';
          
          setHeroBgUrl(defaultHeroUrl);
          setShowcaseImage1(defaultShowcase1);
          setShowcaseImage2(defaultShowcase2);

          dataToSave = { ...data, heroSubtitle: dataToSave.heroSubtitle, showcaseTitle: dataToSave.showcaseTitle, showcaseDesc: dataToSave.showcaseDesc, heroBgUrl: defaultHeroUrl, showcaseImage1: defaultShowcase1, showcaseImage2: defaultShowcase2 };
        } else {
          dataToSave.heroBgUrl = '/hero-dark-premium.png';
          dataToSave.showcaseImage1 = '/premium-project-v6.png';
          dataToSave.showcaseImage2 = '/premium-project-block.png';
          setHeroBgUrl(dataToSave.heroBgUrl);
          setShowcaseImage1(dataToSave.showcaseImage1);
          setShowcaseImage2(dataToSave.showcaseImage2);
        }

        await setDoc(docRef, { ...dataToSave, updatedAt: new Date() }, { merge: true });

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchHomeData();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      const docRef = doc(db, 'pages', 'home');
      await setDoc(docRef, {
        heroTitle,
        heroSubtitle,
        heroBgUrl,
        showcaseTitle,
        showcaseDesc,
        showcaseImage1,
        showcaseImage2,
        updatedAt: new Date()
      }, { merge: true });
      setMessage('Ana sayfa içerikleri başarıyla güncellendi!');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error(err);
      setMessage('Kayıt başarısız oldu.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-zinc-500">Yükleniyor...</div>;

  return (
    <div className="space-y-6 pb-24">
      <div className="mb-6">
        <h2 className="text-2xl font-black text-white uppercase tracking-widest" style={{ fontFamily: 'Raleway, sans-serif' }}>Ana Sayfa Yönetimi</h2>
        <p className="text-zinc-400 text-sm mt-1">Sitenin giriş ekranındaki büyük yazıları ve açıklamaları buradan canlı olarak değiştirebilirsin.</p>
      </div>

      {message && (
        <div className={`p-4 rounded-xl font-bold text-sm ${message.includes('başarısız') ? 'bg-red-500/10 text-red-500' : 'bg-green-500/10 text-green-500'}`}>
          {message}
        </div>
      )}

      {/* HERO BÖLÜMÜ */}
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-8">
        <div className="flex items-center gap-3 mb-6 border-b border-zinc-800 pb-4">
          <i className="ri-layout-top-line text-2xl text-red-500"></i>
          <h3 className="text-lg font-bold text-white uppercase tracking-wider">Açılış Ekranı (Hero)</h3>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Büyük Ana Başlık (Alt satıra geçmek için Enter'a bas)</label>
            <textarea 
              value={heroTitle} 
              onChange={e => setHeroTitle(e.target.value)} 
              rows={2} 
              className="w-full bg-zinc-950 border border-zinc-800 text-white font-black text-xl rounded-xl py-4 px-5 focus:border-red-500 focus:outline-none"
            ></textarea>
          </div>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Açıklama Alt Metni</label>
            <textarea 
              value={heroSubtitle} 
              onChange={e => setHeroSubtitle(e.target.value)} 
              rows={2} 
              className="w-full bg-zinc-950 border border-zinc-800 text-zinc-300 rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none"
            ></textarea>
          </div>
          <div>
             <ImageUploader 
               currentImageUrl={heroBgUrl} 
               onImageUploaded={(url) => setHeroBgUrl(url)} 
               onImageDeleted={() => setHeroBgUrl('')} 
               folderPath="pages/home/hero"
               label="Ana Ekran Arka Plan Görseli"
             />
          </div>
        </div>
      </motion.div>

      {/* SHOWCASE BÖLÜMÜ */}
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-8">
        <div className="flex items-center gap-3 mb-6 border-b border-zinc-800 pb-4">
          <i className="ri-building-4-line text-2xl text-red-500"></i>
          <h3 className="text-lg font-bold text-white uppercase tracking-wider">Bina Tanıtım Alanı</h3>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Bölüm Başlığı</label>
            <input 
              type="text" 
              value={showcaseTitle} 
              onChange={e => setShowcaseTitle(e.target.value)} 
              className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none"
            />
          </div>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Bölüm Açıklaması</label>
            <textarea 
              value={showcaseDesc} 
              onChange={e => setShowcaseDesc(e.target.value)} 
              rows={3} 
              className="w-full bg-zinc-950 border border-zinc-800 text-zinc-300 rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none"
            ></textarea>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ImageUploader 
               currentImageUrl={showcaseImage1} 
               onImageUploaded={(url) => setShowcaseImage1(url)} 
               onImageDeleted={() => setShowcaseImage1('')} 
               folderPath="pages/home/showcase"
               label="1. İkonik Bina Görseli"
             />
             <ImageUploader 
               currentImageUrl={showcaseImage2} 
               onImageUploaded={(url) => setShowcaseImage2(url)} 
               onImageDeleted={() => setShowcaseImage2('')} 
               folderPath="pages/home/showcase"
               label="2. İkonik Bina Görseli"
             />
          </div>
        </div>
      </motion.div>

      {/* DEV KAYDET BUTONU */}
      <div className="fixed bottom-0 left-0 right-0 md:left-64 bg-zinc-950/80 backdrop-blur-lg border-t border-zinc-800 p-4 flex justify-end z-50">
         <button 
           onClick={handleSave} 
           disabled={saving}
           className="bg-red-600 hover:bg-red-700 text-white font-black text-lg py-4 px-12 rounded-xl shadow-2xl shadow-red-600/30 transition-all flex items-center gap-3 disabled:opacity-50"
         >
           {saving ? <i className="ri-loader-4-line animate-spin"></i> : <i className="ri-save-3-line"></i>}
           ANA SAYFAYI KAYDET VE YAYINLA
         </button>
      </div>
    </div>
  );
}
